import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import type { OnlyIdRequiredInterface } from '@zaoblako/shared/common/interfaces/only-id-required.interface';
import type { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { HelpDeskTaskTypeService } from '@zaoblako/web/core/services/helpdesk/help-desk-task-type.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-hd-task-type-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './hd-task-type-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HdTaskTypeSingleSelectComponent implements OnInit {
  @Input() public taskTypes: HelpdeskTaskTypeFindInterface[] = [];
  @Input() public loading = false;
  public internalLoading = false;

  @Input() public selectedTaskType:
    | HelpdeskTaskTypeFindInterface
    | OnlyIdRequiredInterface<HelpdeskTaskTypeFindInterface>;

  @Output() public selectedTaskTypeChange = new EventEmitter<HelpdeskTaskTypeFindInterface>();

  @Output() public changeValue = new EventEmitter<HelpdeskTaskTypeFindInterface>();

  @Input() public customRequest = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public showClear = false;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public appendTo: string;

  public constructor(
    private readonly taskTypeService: HelpDeskTaskTypeService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly globalService: GlobalService
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      this.globalService.globalInfo.tenantInfo?.ratePlan?.modulesAccessControl?.HELPDESK?.enabled
    ) {
      this.internalLoading = true;
      this.taskTypeService.find<HelpdeskTaskTypeFindInterface>().subscribe({
        next: (taskTypes) => {
          this.taskTypes = taskTypes;
          this.internalLoading = false;
          this.cdRef.markForCheck();
        },
        error: () => {
          this.internalLoading = false;
          this.cdRef.markForCheck();
        }
      });
    }
  }
}
